import Close from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'
import { colors } from 'styles/theme'

interface Props {
  onClose?: () => void
  children: ReactNode
}

const Header = ({ onClose, children }: Props) => {
  return (
    <Container close={!!onClose}>
      <Typography variant="h2" sx={{ fontSize: 16, fontWeight: 600 }}>
        {children}
      </Typography>
      {onClose && (
        <IconButton
          aria-label="close modal"
          onClick={onClose}
          sx={{ color: colors.gray[400] }}
        >
          <Close fontSize="small" />
        </IconButton>
      )}
    </Container>
  )
}

const Container = styled(Box)<{ close?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ close }) => (close ? '16px 24px' : '24px')};
  border-bottom: 1px solid ${colors.gray[100]};
`

export default Header
